// packages/main/app/web/components-v2/UnifiedImageDialog/AIGenerateTab.tsx
import * as Api from '@ViewModels';
import * as React from 'react';
import { AIImageChat } from './AIImageChat';

interface AIGenerateTabProps {
	onImageSelected: (image: Api.IFileAttachment) => void;
	impersonationContext?: Api.IImpersonationContext;
}

export function AIGenerateTab({ onImageSelected, impersonationContext }: AIGenerateTabProps) {
	// Adapt AIImageChat's array callback to AIGenerateTab's single image callback
	const handleImageSelected = React.useCallback(
		(fileAttachments: Api.IFileAttachment[]) => {
			if (fileAttachments.length > 0) {
				onImageSelected(fileAttachments[0]);
			}
		},
		[onImageSelected]
	);

	return <AIImageChat onImageSelected={handleImageSelected} impersonationContext={impersonationContext} />;
}
